//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import NewTaskCard from './new-task-card.vue';
import TaskCard from './task-card.vue';
import TasksList from './tasks-list.vue';
import TaskViewBreadcrumbs from './task-view-breadcrumbs.vue';
import TaskViewHeader from './task-view-header.vue';
import ActionMenu from './action-menu.vue';
import TaskViewDetails from './task-view-details.vue';
import DropZone from './drop-zone.vue';
import {
  reorderTasks,
  withoutSubtaskOf,
} from '../ordered-relation.js';
import {isSubtask} from '../utils.js'
import {
  deleteItem,
  findMoveToParentTarget,
} from '../db-utils.js';
import {
  calcItemColor,
  upFromTaskView,
  calcVisibility,
} from '../utils.js';

export default {
  data() {
    return {
      color: undefined,
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  components: {
    NewTaskCard,
    TaskCard,
    TasksList,
    TaskViewBreadcrumbs,
    TaskViewHeader,
    ActionMenu,
    TaskViewDetails,
    DropZone,
  },
  computed: {
    taskId() {
      return this.$route.params.taskId;
    },
    task() {
      if (!this.$reactiveCache) {
        return null;
      }
      return this.$reactiveCache.docs[this.taskId] || null;
    },
    elements() {
      if (this.taskId) return this.task.getChildren();
      return [];
    },
    visibleElements() {
      return this.elements.filter(this.visible);
    },
    hiddenElemsCount() {
      return this.elements.length - this.visibleElements.length
    },
    itemColor() {
      return calcItemColor(this.task, this.$reactiveCache);
    },
    toggleDoneText() {
      return this.$root.showDone
        ? this.$gettext('hide done tasks')
        : this.$gettext('show done tasks') + ` (${this.hiddenElemsCount})`
    },
  },
  methods: {
    isSubtask,
    visible(task) {
      return calcVisibility(task, this);
    },
    toggleShowDone() {
      this.$root.showDone = !this.$root.showDone;
    },
    goBack() {
      this.$router.back()
    },
    goUp() {
      this.$taskCardsController.selectedTasksIds = null
      upFromTaskView(this);
    },
    dropAtTheEnd() {
      this.$taskCardsController.finalizeAttaching(this.task._id);
    },
    moveToParent() {
      const reorderOptions = findMoveToParentTarget(this.$reactiveCache, this.task)
      const tasks = Object.keys(this.$taskCardsController.attachCandidatesIds).map(
        (id) => this.$reactiveCache.docs[id]
      );

      // tasks may no longer be nested if they are moved to a date section.
      const modifiedTasks = tasks.map((task) => withoutSubtaskOf(task));

      let promise;
      reorderOptions.reactiveCache = this.$reactiveCache;
      reorderOptions.tasks = modifiedTasks;
      promise = reorderTasks(reorderOptions);

      promise.catch((error) => {
        // TODO: Show the error in UI, handle it sensibly.
        console.error(error);
      });

      this.$taskCardsController.leaveSpecialState();
    },
    handleAddElemQuery() {
      if ('add_element' in this.$route.query) {
        const elem_type = this.$route.query.add_element;
        // Remove the query. A bit heavy-handed, but effective.
        this.$router.replace(this.$route.path);
        this.$refs.newTaskCard.openInput(elem_type)
      }
    },
    updatePageTitle() {
      if (!this.task) return 'Not found'
      const maxLen = 52
      name = this.task.name.length <= maxLen
        ? this.task.name
        : this.task.name.slice(0, maxLen) + '...'
      document.title = name + ' – ' + this.$root.appName
    }
  },
  mounted() {
    this.handleAddElemQuery();
    this.updatePageTitle();
  },
  destroyed() {
    document.title = this.$root.appName
  },
  beforeUpdate() {
    this.handleAddElemQuery();
    this.updatePageTitle();
  },
};
